module.exports = __webpack_public_path__ + "img/icn_landing_productive.a8239d03.svg";